import * as yup from "yup";

const documentValidation = yup.object().shape({
  name: yup.string().required("Bu alan zorunludur"),
});

export default documentValidation;
